<template>
	<div>
		<div class="enterprise">
			<div class="enterprise-title">企业文化</div>
			<div class="enterprise-list">
				<div :class="idx==0?'big-img':''">
					<img src="../../assets/img/enterprise-big-1.png" alt="">
					<!-- <img v-else src="../../assets/img/enterprise-1.png" alt=""> -->
					<div class="tag" @click="changeIdx(0)">
						<div>
							<div :class="idx==0?'tag-title':''">互助</div>
							<div  v-if="idx==0">最好的满足就是给别人以满足</div>
						</div>
					</div>
				</div>
				<div :class="idx==1?'big-img':''">
					<img src="../../assets/img/enterprise-big-2.png" alt="">
					<!-- <img v-else src="../../assets/img/enterprise-2.png" alt=""> -->
					<div class="tag" @click="changeIdx(1)">
						<div>
							<div :class="idx==1?'tag-title':''">坚守</div>
							<div v-if="idx==1">每一位客户都赤诚以待 将产品和服务做到极致</div>
						</div>
					</div>
				</div>
				<div :class="idx==2?'big-img':''">
					<img src="../../assets/img/enterprise-big-3.png" alt="">
					<!-- <img v-else src="../../assets/img/enterprise-3.png" alt=""> -->
					<div class="tag" @click="changeIdx(2)">
						<div>
							<div :class="idx==2?'tag-title':''">分享</div>
							<div v-if="idx==2">开放和拥抱是公司永恒的主题</div>
						</div>
					</div>
				</div>
				<div :class="idx==3?'big-img':''">
					<img src="../../assets/img/enterprise-4.png" alt="">
					<div class="tag" @click="changeIdx(3)">
						<div>
							<div :class="idx==3?'tag-title':''">成长</div>
							<div v-if="idx==3">共同成长是公司对每一位客户和员工的承诺</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				idx:3
			}
		},
		methods:{
			changeIdx(i){
				this.idx=i
			}
		}
	})
</script>

<style lang="scss" scoped>
	.enterprise{
		padding:4rem 2rem;
		.enterprise-title{
			font-size: 1.9rem;
			color: #000000;
			line-height: 2.9rem;
			font-weight: 600;
			text-align: center;
		}
		.enterprise-list{
			margin-top:2rem;
			display:flex;
			>div{
				margin-left:.6rem;
				width:8rem;
				height:23.7rem;
				position: relative;
				transition: all .3s linear;
				&:nth-child(1){
					margin-left:0;
				}
				>img{
					width:100%;
					height:100%;
					object-fit:cover;
				}
				&.big-img{
					flex:1;
					>img{
						width:100%;
						height:100%;
					}
				}
				.tag{
					height:100%;
					width:100%;
					position: absolute;
					left:0;
					top:0;
					display:flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-end;
					box-sizing: border-box;
					padding-bottom:1.6rem;
					font-size: 1.2rem;
					line-height: 1.6rem;
					color:#fff;
					background: rgba(0,0,0,0.32) linear-gradient(180deg, rgba(0,0,0,0) 68%, #000000 100%);
					cursor: pointer;

					>div{
						font-size: 0.8rem;
						color: rgba(255,255,255,0.85);
						line-height: 1.6rem;
						.tag-title{
							font-size: 1.2rem;
							color: #FFFFFF;
							line-height: 1.6rem;
							font-weight: 600;
							display:inline-block;
							padding:.2rem 0;
							border-bottom:0.1rem solid #FFFFFF;
							margin-bottom:.8rem;
						}
					}
				}
			}
		}
		
	}
</style>